import { type ReactElement } from 'react'
import { useTranslation } from '@front/model'
import { TextInput } from '@mantine/core'
import { type UseFormReturnType } from '@mantine/form'
import { ParentTeamSelect } from './ParentTeamSelect'
import { type AddTeamValues } from './types'

type Props = {
  levelName: string
  form: UseFormReturnType<AddTeamValues>
  allowParentSelect?: boolean
}
export const AddTeamForm = ({ levelName, form, allowParentSelect }: Props): ReactElement => {
  const { t } = useTranslation()
  const label = t('{{levelName}} name', { levelName })
  return (
    <>
      <TextInput
        withAsterisk
        label={label}
        placeholder={t('Enter {{levelName}} name', { levelName })}
        {...form.getInputProps('name')}
      />
      <ParentTeamSelect allowParentSelect={allowParentSelect} form={form} />
    </>
  )
}
